import { render } from "./BancosPage.vue?vue&type=template&id=557ebad0"
import script from "./BancosPage.vue?vue&type=script&lang=js"
export * from "./BancosPage.vue?vue&type=script&lang=js"

import "./BancosPage.vue?vue&type=style&index=0&id=557ebad0&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__